export default function facilityOfficialDocuments() {
  return [
    { name: 'Facility Lease', url: '' },
    { name: 'HVAC Maintenance', url: '' },
    { name: 'Utility Information', url: '' },
    { name: 'Equipment Leases', url: '' },
    { name: 'W9', url: '' },
    { name: 'Customer License', url: '' },
    { name: 'Floor Plan', url: '' },
    { name: 'Flyer', url: '' },
  ];
}



// WEBPACK FOOTER //
// ./src/utils/facilityOfficialDocuments.js